// extracted by mini-css-extract-plugin
export default {"head":"styles_head__dsunZ","head_info":"styles_head_info__Jcal8","caption":"styles_caption__vuD6T","avatar":"styles_avatar__lbxmf"};